import React, { useEffect, useState } from "react";
import { RiUser6Line } from "react-icons/ri";
import { HiOutlineClock, HiOutlineXCircle, HiOutlineLockClosed } from "react-icons/hi2";
import { LuHeadset } from "react-icons/lu";
import apiRequests from "../axios/config/config";
import toast from "react-hot-toast";
import WebLogo from "../../assets/image/webLogo.png";
import gmail from "../../assets/image/gmail.png";
import Loading from "../Loading/Loading";
import { Link, useNavigate } from "react-router-dom";
import loginIcon from "../../assets/image/loginIcon.png";
import keyIcon from "../../assets/image/keyIcon.png";
import userIcon from "../../assets/image/userIcon.png";
import { AiOutlineEye } from "react-icons/ai";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import loginpic from "../../assets/image/loginPic.svg";
import { CgSpinner } from "react-icons/cg";

export default function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [accountStatus, setAccountStatus] = useState(null);

  useEffect(() => {
    const token =
      localStorage.getItem("accessToken") ||
      sessionStorage.getItem("accessToken");

    if (token) {
      navigate("/", { replace: true });
    }
  }, [navigate]);

async function loginAPI() {
  try {
    setLoading(true);
    const response = await apiRequests.post("seller/v1/login-seller", {
      userName: username,
      password: password,
    });

    const token = response.data.data.tokens.accessToken;

    if (checked) {
      localStorage.setItem("accessToken", token);
    } else {
      sessionStorage.setItem("accessToken", token);
    }

    const profileResponse = await apiRequests.get(
      "/seller/v1/get-my-profile",
    );
    const status = profileResponse.data.data.status;

    if (status === "pending" || status === "rejected") {
      localStorage.removeItem("accessToken");
      sessionStorage.removeItem("accessToken");
      setAccountStatus(status);
      return;
    }

    localStorage.setItem("rememberMe", checked ? "true" : "false");
    toast.success("Login successful");
    navigate("/");
  } catch (err) {
    console.log(err);
    toast.error(err?.response?.data?.en_message || "Login failed");
  } finally {
    setLoading(false);
  }
}

  return (
    <div className="grid grid-cols-2 md:flex md:h-screen md:justify-center md:items-center">
      <div className="col-span-1 h-screen md:hidden flex flex-col items-center bg-[#051F33] gap-6 ">
        <div className="mt-12">
          <h3 className=" text-white font-inter flex justify-center -mb-2">
            Welcome to
          </h3>
          <div className="flex flex-row gap-4">
            <img src={WebLogo} alt="webLogo" width={42} height={42} />
            <h1 className="text-white flex font-asap items-center text-[40px] tracking-wide  ">
              clan
              <span className="text-[#47B26E] font-asap font-bold text-4xl relative -bottom-3">
                S
              </span>
              mart
            </h1>
          </div>
        </div>
        <img className="w-30 h-90" src={loginpic} alt="loginImage" />

        <div>
          <p className="text-white font-inter text-center">
            The trusted marketplace for <br />
            customers, stores, and home cooks
          </p>
        </div>
      </div>
      <div className="flex justify-center h-full items-center p-3 text-center col-span-1 md:col-span-2 md:w-full bg-[#F0E8E4] ">
        <div className="text-black border-2 overflow-hidden rounded-2xl shadow-2xl bg-white p-8 w-[60%] md:w-full items-center justify-center flex flex-col gap-4">
          {accountStatus === "pending" || accountStatus === "rejected" ? (
            <div className="flex flex-col items-center justify-center gap-4 py-8 px-4">
              <div
                className={`w-20 h-20 rounded-full flex items-center justify-center ${
                  accountStatus === "pending"
                    ? "bg-amber-100 text-amber-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {accountStatus === "pending" ? (
                  <HiOutlineClock className="w-10 h-10" />
                ) : (
                  <HiOutlineXCircle className="w-10 h-10" />
                )}
              </div>

              <p className="text-2xl font-semibold text-[#051F33]">
                {accountStatus === "pending"
                  ? "Awaiting Approval"
                  : "Application Rejected"}
              </p>

              <p className="text-gray-500 max-w-sm leading-relaxed">
                {accountStatus === "pending"
                  ? "You have been registered. Please wait for the admin to approve your account."
                  : "You have been rejected by the admin."}
              </p>

              <button
                onClick={() => setAccountStatus(null)}
                className="mt-2 bg-[#051F33] text-white px-6 py-2 rounded-lg hover:bg-[#0a3455] transition-colors"
              >
                Back to Login
              </button>
            </div>
          ) : (
            <>
              <div className="flex items-center justify-center gap-3">
                <div className="flex flex-col items-center justify-center">
                  <p className="text-3xl font-semibold ">Login</p>
                </div>
              </div>

              <div className="flex flex-col justify-start gap-2 w-full">
                <div className="border border-neutral-400 flex items-center justify-between px-5 py-2 rounded-lg ">
                  <img className="w-5 h-5" src={userIcon} alt="usericon" />
                  <input
                    className="pl-2 outline-0 w-full placeholder:text-gray-500 focus:outline-none"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="User name"
                  />
                </div>
              </div>

              <div className="flex flex-col justify-start gap-1 w-full ">
                <div className="border border-neutral-400 flex items-center rounded-lg justify-between px-5 py-2">
                  <img className="w-5 h-5" src={keyIcon} alt="keyicon" />
                  <input
                    className="pl-2 outline-0 w-full placeholder:text-gray-500 focus:outline-none"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                  />

                  <div onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? (
                      <AiOutlineEyeInvisible className="w-6 h-6 text-gray-500 " />
                    ) : (
                      <AiOutlineEye className="w-6 h-6 text-gray-500 " />
                    )}
                  </div>
                </div>
              </div>
              <label className="flex items-center gap-2 justify-start w-full cursor-pointer">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setChecked(e.target.checked);
                    localStorage.setItem(
                      "rememberMe",
                      e.target.checked ? "true" : "false",
                    );
                  }}
                  className="w-4 h-4"
                />

                <p className="text-slate-500">Remember me</p>
              </label>

              <button
                onClick={loginAPI}
                className="bg-[#051F33] w-full flex justify-center items-center text-white px-5 py-2 rounded-lg gap-2"
              >
                {loading ? (
                  <CgSpinner className="animate-spin" size={30} />
                ) : (
                  "Login"
                )}
                {!loading && <img className="w-5 h-5" src={loginIcon} />}
              </button>

              <div className="flex gap-1 justify-center">
                <a
                  href={"/register"}
                  className="text-[#2196F3] hover:cursor-pointer"
                >
                  Dont have an account? Sign up
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}